import { StreamType } from "../../interface";

export const ROOM_STAGE_VIDEO_STREAM_TYPE: StreamType[] = [
  "camMic",
  "localVideoFile",
  "screen"
];
